import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema4/T4_paneles_s2a2.glb";
import { GUI } from "dat.gui";
// import gsap from "gsap";

export class PanelesTeclado extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.511, -0.9126, -1.8332);
		this.rotation.set(Math.PI / 2, 3.3, Math.PI / 2);
		this.scale.set(0.5, 0.5, 0.5);
		// this.helpers()
	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.panelS = gltf.scene.getObjectByName("S", true);
			this.panelF6 = gltf.scene.getObjectByName("F6", true);
			this.panelService = gltf.scene.getObjectByName("Service", true);
			this.panelF = gltf.scene.getObjectByName("F", true);
			this.panelBorrar = gltf.scene.getObjectByName("Borrar", true);
			this.panelF8 = gltf.scene.getObjectByName("F8", true);
			this.panelT = gltf.scene.getObjectByName("T", true);
			this.panelA = gltf.scene.getObjectByName("A", true);
			this.panelRepetirArticulo = gltf.scene.getObjectByName("RepetirArticulo", true);

			this.visible = false
			this.panelS.position.set(-0.36, 0.67, 0)
			this.panelF6.position.set(0, 0.36, 0)
			this.panelService.position.set(0.36, 0.47, 0)
			this.panelF.position.set(-0.08, 0.67, 0)
			this.panelBorrar.position.set(0.18, 0.76, 0)
			this.panelF8.position.set(0.24, 0.36, 0)
			this.panelT.position.set(0.03, 0.96, 0)
			this.panelA.position.set(-0.5, 0.88, 0)
			this.panelRepetirArticulo.position.set(-0.5, 0.36, 0)

			this.panelS.visible = false
			this.panelF6.visible = false
			this.panelService.visible = false
			this.panelF.visible = false
			this.panelBorrar.visible = false
			this.panelF8.visible = false
			this.panelT.visible = false
			this.panelA.visible = false
			this.panelRepetirArticulo.visible = false

			this.panelesArray = [
				this.panelS,
				this.panelF6,
				this.panelService,
				this.panelF,
				this.panelBorrar,
				this.panelF8,
				this.panelT,
				this.panelA,
				this.panelRepetirArticulo,
			]
		})
	}
	showSelectedPanel(panelName) {
		this.panelesArray.forEach(item => {
			if (item.name === panelName) {
				item.visible = true
			} else {
				item.visible = false
			}
		})
	}
	hidePanels() {
		this.panelesArray.forEach(item => item.visible = false)
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Paneles");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	helpersChild() {
		this.helpersMethod("S", this.panelS);
		this.helpersMethod("F6", this.panelF6);
		this.helpersMethod("Service", this.panelService);
		this.helpersMethod("F", this.panelF);
		this.helpersMethod("Borrar", this.panelBorrar);
		this.helpersMethod("F8", this.panelF8);
		this.helpersMethod("T", this.panelT);
		this.helpersMethod("A", this.panelA);
		this.helpersMethod("Repetir", this.panelRepetirArticulo);
	}
	helpersMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

}